export default {"src":"/_next/static/media/close-arrows.2f657ff5.svg","height":24,"width":24};